/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LanguageModel } from '../../models/language-model';

export interface SearchClientIdLanguageGet$Json$Params {
  clientId: string;
}

export function searchClientIdLanguageGet$Json(http: HttpClient, rootUrl: string, params: SearchClientIdLanguageGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<LanguageModel>>> {
  const rb = new RequestBuilder(rootUrl, searchClientIdLanguageGet$Json.PATH, 'get');
  if (params) {
    rb.path('clientId', params.clientId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<Array<LanguageModel>>;
    })
  );
}

searchClientIdLanguageGet$Json.PATH = '/Search/{clientId}/Language';
